const HCPAssignmentMessageType = Object.freeze({
    HCP_BEGIN_ASSIGNMENT: 0,
    HCP_TOKEN_ERROR: 1,
    DEVICE_ALREADY_ASSIGNED: 2,
    DEVICE_ALREADY_ASSIGNED_TO_OTHER_ORGANISATION: 3,
    HCP_ASSIGNMENT_COMPLETE: 4,
    // Mirrors DigosticsGTT.API.DiagnosticsService HCPAssignmentMessageType - append only
    DEVICE_FAILED_CHECKS: 5
})

export default HCPAssignmentMessageType